// extracted by mini-css-extract-plugin
module.exports = {"container":"inputteam-name_container__3PM4x","createoption":"inputteam-name_createoption__2SeQS","newValue":"inputteam-name_newValue__10ffG"};